import { Component, inject } from '@angular/core';
import {
  ClientsService,
  SelectedClient,
} from 'src/app/services/clients/clients.service';
import { HeaderComponent } from '../dashboard/header/header.component';
import { CreditSummaryComponent } from './credit-summary/credit-summary.component';
import { CreditHistoryComponent } from './credit-history/credit-history.component';
import { CreditTransfersComponent } from './credit-transfers/credit-transfers.component';
import { PaymentMethodsComponent } from './payment-methods/payment-methods.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-credit-page',
  templateUrl: './credit-page.component.html',
  styleUrls: ['./credit-page.component.scss'],
  imports: [
    HeaderComponent,
    CreditSummaryComponent,
    CreditHistoryComponent,
    CreditTransfersComponent,
    PaymentMethodsComponent,
    TranslateModule,
  ],
})
export class CreditPageComponent {
  private clientsService = inject(ClientsService);

  get client(): SelectedClient | null {
    return this.clientsService.selectedClientSubject.value;
  }
}
